import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Root } from './Settings.css';
import * as reducer from './Settings.reducer';
import PageTitle from '../Layout/components/PageTitle';
import { TextField, Button } from '@material-ui/core';
import Toast from '../Layout/components/Toast';
import userDao from '../../request/userDao';

class Settings extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            oldPwdHelperText: "",
            isError: false,
            isOldPwdError: false,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            isOldPwdError,
            isError,
            helperText,
            oldPwdHelperText,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <div className="head h">
                    <PageTitle title="All SETTINGS" subtitle="MANAGEMENT"></PageTitle>
                </div>
                <div className="wapper">
                    <div>
                    </div>
                    <div>
                        <div className="title">Change Password</div>
                        <div className="line"></div>
                        <div className="textWapper v">
                            <TextField
                                required
                                id="outlined-required"
                                label="Old password"
                                className="textField"
                                margin="dense"
                                variant="outlined"
                                onChange={e => this.handleChange(e, "oldPassword")}
                                error={isOldPwdError}
                                helperText={oldPwdHelperText}
                                type="password"
                            />
                            <TextField
                                required
                                id="outlined-required2"
                                label="New password"
                                className="textField"
                                margin="dense"
                                variant="outlined"
                                onChange={e => this.handleChange(e, "newPassword")}
                                error={isError}
                                helperText={helperText}
                                type="password"
                            />
                            <TextField
                                required
                                id="outlined-required3"
                                label="Confirm new password"
                                className="textField"
                                margin="dense"
                                variant="outlined"
                                onChange={e => this.handleChange(e, "confirmNewPassword")}
                                error={isError}
                                helperText={helperText}
                                type="password"
                            />
                        </div>
                        <div className="line"></div>
                        <Button variant="contained" color="primary" onClick={this.handleClick}>SAVE CHANGES</Button>
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    handleClick() {
        const { oldPassword, newPassword, confirmNewPassword } = this.state;
        let oldPwd = localStorage.getItem('pwd');
        console.log(oldPwd);
        if (oldPassword !== oldPwd) {
            this.oldPwdError();
            return;
        }
        if (newPassword === "" || confirmNewPassword === "") {
            this.showToast("New password cannot be empty");
            return;
        }
        if (newPassword === confirmNewPassword) {
            this.changePassword(newPassword);
        } else {
            this.passwordError();
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }));
        this.clearError();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    changePassword(value) {
        const { history } = this.props;
        let params = {
            password: value
        }
        userDao.updateUserInfo(params,(res)=>{
            if (res.data.error === 0) {
                this.showToast("Password changed successfully, please login again", "success");
                history.push({ pathname: '/login' });
            }
        })
    }
    oldPwdError() {
        this.setState(() => ({
            isOldPwdError: true,
            oldPwdHelperText: "wrong password"
        }));
    }
    passwordError() {
        this.setState(() => ({
            isError: true,
            helperText: "Incorrect password entered twice"
        }));
    }
    clearError() {
        this.setState(() => ({
            isError: false,
            helperText: "",
            isOldPwdError: false,
            oldPwdHelperText: ""
        }));
    }
}

// store映射
const mapStateToProps = (state) => {
    return {
        show: state.getIn(['home', 'show'])
    }
}
const mapDispathToProps = (dispath) => {
    return {
        setShow: (value) => {
            dispath(reducer.getList());
            dispath(reducer.showAction(value));
        }
    }
}

export default connect(mapStateToProps, mapDispathToProps)(withRouter(Settings));